import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Header from "../Header";

const Container = styled.div`
position: absolute;
margin-top: ${props => props.center ? "10rem" : ""};
width: 100%;
@media (min-width: 959px) {
  flex-direction: column;
  margin-top: 0;
}
`;

const Background = styled.div`
background-image: url("/images/profile_background.jpg");
background-position: center;
background-repeat: no-repeat;
background-size: cover;
position: fixed;
height: 100vh;
width: 100vw;
`;

function Layout(props) {
  const { children, background, center, toLogout } = props;

  return (
    <>
      {background ? <Background /> : <></>}
      <Header toLogout={toLogout} />
      <Container center={center}>
        
        {children}
      </Container>
    </>
  );
}

export default Layout;
